import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import {
  EARN_CATALOG_COLLECTION,
  EARN_CATALOG_DOC_ID,
  setActiveEarnCoins,
} from '../services/users/earnCatalog';

/** Keep the in-memory earn table aligned with appConfig/earnCatalog. */
export function startEarnCatalogSync() {
  const ref = doc(db, EARN_CATALOG_COLLECTION, EARN_CATALOG_DOC_ID);
  return onSnapshot(
    ref,
    (snap) => {
      if (!snap.exists()) return;
      setActiveEarnCoins(snap.data()?.coins);
    },
    () => {
      /* Missing rules or a dropped listener keeps the last known amounts. */
    }
  );
}
